:host {
  --uui-panel-padding: var(--uui-large-padding) var(--uui-x-large-padding);
  --uui-panel-body-overflow: hidden;
  --uui-panel-border-top: 1px solid var(--uui-theme-variant-300);
  --uui-panel-border-bottom: 1px solid var(--uui-theme-variant-300);
  --uui-panel-title-icon: var(--uui-panel-title-icon-collapsed);
  --uui-panel-body-transition: height 0.3s ease-out;
  --uui-panel-body-padding-top: var(--uui-x-large-padding);
  --uui-panel-background-color: var(--uui-theme-variant-800);
}

:host([expanded]) {
  --uui-panel-body-overflow: hidden;
  --uui-panel-title-icon: var(--uui-panel-title-icon-expanded);
}

:host([expanded]) div.panel-bg {
  background: var(--uui-panel-background-color);
}

:host([expanded]) ::slotted(uui-expansion-panel-header) {
  --uui-panel-title-color: var(--uui-theme-core-600);
}

:host([variant="light"]) ::slotted(uui-expansion-panel-header) {
  --uui-panel-title-font-weight: var(--uui-font-weight-light);
}

:host([variant="small"]) ::slotted(uui-expansion-panel-header) {
  --uui-panel-title-font-size: 1.25rem;
  --uui-panel-title-line-height: var(--uui-default-line-height);
}

div {
  padding: var(--uui-panel-padding);
  border-top: var(--uui-panel-border-top);
  border-bottom: var(--uui-panel-border-bottom);
}

@media screen and (max-width: 768px) {
  :host ::slotted(uui-expansion-panel-header) {
    --uui-panel-title-font-size: 1.375rem;
    --uui-panel-title-line-height: var(--uui-default-line-height);
  }

  :host([variant="small"]) ::slotted(uui-expansion-panel-header) {
    --uui-panel-title-font-size: var(--uui-large-font-size);
    --uui-panel-title-line-height: 1.5rem;
  }
}
